import { render } from "./Date.vue?vue&type=template&id=310ddb3a"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"
script.render = render

export default script